import React from "react";
import Modal from "react-modal";
import "./CustomModal.css";
import FeatherIcon from "feather-icons-react";
import { useIsHiddenForPreview } from "../../contexts/PreviewHiddenContext";

export const CustomModal = ({ isOpen, onClose, children, maxWidth, compact, centered, hideCloseButton, noAnimation }) => {
    // Same portal-escapes-display:none problem BottomSheetPanel.jsx has
    // (react-modal also portals straight to document.body by default) - a
    // modal left open in the background Tournament copy that App.js hides
    // behind the "Screen size" preview would otherwise stay visible (full
    // dimmed overlay included) on top of the preview. See
    // PreviewHiddenContext.js.
    const isHiddenForPreview = useIsHiddenForPreview();
    if (isHiddenForPreview) return null;

    const overlayClassName = [
        "modal-overlay",
        compact && "modal-overlay-compact",
        centered && "modal-overlay-centered",
        noAnimation && "modal-overlay-no-anim",
    ].filter(Boolean).join(" ");

    return (
        <Modal
            isOpen={isOpen}
            overlayClassName={overlayClassName}
            bodyOpenClassName={"modal-open"}
            shouldFocusAfterRender={false}
            shouldReturnFocusAfterClose={false}
            className={`modal-content${compact ? " modal-content-compact" : ""}${centered ? " modal-content-centered" : ""}${noAnimation ? " modal-content-no-anim" : ""}`}
            closeTimeoutMS={noAnimation ? 0 : 300}
            onRequestClose={() => onClose()}
            ariaHideApp={false}
            style={maxWidth ? { content: { "--modal-max-width": maxWidth } } : {}}
        >
            {/* Some callers render their own close icon inside a custom sticky
                header (ClubProfileModal/PlayerProfileModal/RatingTable) to
                keep it in line with other icons in that same row - hideCloseButton
                skips this default one so those don't end up with two
                overlapping X's, the wrapper's own always sitting on top since
                it was never actually conditional before. */}
            {!hideCloseButton && (
                <div className="modal-close" onClick={() => onClose()}>
                    <FeatherIcon icon="x" />
                </div>
            )}
            {children}
        </Modal>
    );
};